import React from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import { Parallax } from 'react-scroll-parallax';

import { dispatchResizeEvent } from 'helpers/window';
import RichEditorContent from 'components/RichEditorContent';
import AbstractCmsElement from './AbstractCmsElementNew';

class CmsElementCarouselChild extends AbstractCmsElement {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
  }

  componentDidMount = () => {
    let img = new Image();
    img.onload = () => {
      dispatchResizeEvent();
    };
    img.src = this.getParamValue('imageUrl');
    this.__componentDidMount();
  };

  componentWillUnmount = () => {
    this.__componentWillUnmount();
  };

  componentDidUpdate = prevProps => {
    if (this.getPrevParamValue(prevProps, 'imageUrl') !== this.getParamValue('imageUrl')) {
      let img = new Image();
      img.onload = () => {
        dispatchResizeEvent();
      };
      img.src = this.getParamValue('imageUrl');
    }
    this.__componentDidUpdate(prevProps);
  };

  render() {
    const { layout, index, editMode } = this.props;

    const imageUrl = this.getParamValue('imageUrl', null);
    const isFullHeight = this.getParamValue('fullHeight', 'no') === 'yes';

    const headerStyle = {
      height: isFullHeight ? layout.height + 'px' : 'auto',
    };

    const vAlign = this.getParamValue('vAlign', 'top');
    let vAlignClass = '';
    if (vAlign === 'middle') {
      vAlignClass = 'col-middle ';
    } else if (vAlign === 'bottom') {
      vAlignClass = 'col-bottom ';
    }

    const isFirstGrid = index.toString().charAt(0) === '0';

    return (
      <div
        id={this.getMainId()}
        className="ms-carousel-child jumbotron bg-transparent full-height no-padding no-margin"
        ref={this.containerRef}
      >
        {this.getElementStyle()}

        <Parallax
          opacity={[1, 0]}
          speed={-3}
          disabled={editMode || !isFullHeight}
          className="full-height"
        >
          <div
            className="container-fluid no-padding"
            style={{
              ...headerStyle,
              ...this.getBackgroundStyle(),
            }}
          >
            <div
              className="inner full-height"
              style={{
                backgroundImage: isFullHeight && imageUrl ? 'url(' + imageUrl + ')' : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              <div className={'full-height ' + (isFirstGrid ? 'content ' : '')} style={{ position: 'relative' }}>
                {!isFullHeight && imageUrl ? (
                  <div className="w-100">
                    <img src={imageUrl} style={{ width: '100%' }} />
                  </div>
                ) : null}

                <div
                  className={vAlignClass}
                  style={
                    !isFullHeight && imageUrl
                      ? { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }
                      : {}
                  }
                >
                  <Container>
                    <Row>
                      <Col xs={12} className={'text-' + this.getParamValue('mainColor', 'master')}>
                        <RichEditorContent content={'<div>' + this.getParamValue('content', '') + '</div>'} />
                      </Col>
                    </Row>
                  </Container>
                </div>
              </div>
            </div>
          </div>
        </Parallax>
      </div>
    );
  }
}

CmsElementCarouselChild.defaultProps = {
  index: '0',
};

const mapStateToProps = state => {
  return {
    layout: state.layout,
  };
};

export default connect(mapStateToProps)(CmsElementCarouselChild);
